import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(private http: HttpClient) {
  }

  addAction(body: any) {
    return this.http.post('/api/history/action/', body).subscribe((response) => {});
  }

  fetchActions(link: string) {
    const url = link ? link : '/api/history/action/';
    return this.http.get(url);
  }

  fetchMin() {
    const url = '/api/history/get_min/';
    return this.http.get(url);
  }

}
